import React from "react";
import lodash from "lodash";
import PATHS from "config/paths";

/* eslint-disable react-hooks/exhaustive-deps */

export function useDeleteTask(token, requestTask, isConfirmed) {
  const [response, setResponse] = React.useState();
  const [error, setError] = React.useState();
  const [isLoading, setIsLoading] = React.useState(false);
  const [task, setTask] = React.useState();


  /**
   * Compare requestBody to task so we don't infinite loop
   */
  React.useEffect(() => {
    if (!lodash.isEqual(requestTask, task) &&  isConfirmed) {
      setError(undefined);
      setResponse(undefined);
      setTask(requestTask);
      setIsLoading(true);
    }
  }, [requestTask, setTask,  isConfirmed]);

  /**
   * Make Request
   */
  React.useEffect(() => {
    if (token && task ) {
      const options = {
        method: "DELETE",
        headers: {
          Accept: "application/json",
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        }
      };

      const path = `${PATHS.apiTasks}/${task.id}`;

      async function postRequest() {
        const request = await fetch(path, options);
        return true;
      }

      // Delete returns 204 No Content so it does not have a body, setResponse to true
      postRequest()
        .then(async (response) => {      
           setResponse(response)
          })
          .catch((err) => {
            setError(err);
          })
          .finally(() => {
            setIsLoading(false);
          });
    }
  }, [token, task, setResponse]);

  return { taskDeleteSuccess: response, taskDeleteError: error, taskIsLoading: isLoading };
}
